import script from "./VoiceAnalysisCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceAnalysisCard.vue?vue&type=script&setup=true&lang=js"

import "./VoiceAnalysisCard.vue?vue&type=style&index=0&id=0bbc5646&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbc5646"]])

export default __exports__